/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_DeactivateInputs */

const cs_templates_deactivate = /** @type {(inputs: Templates_DeactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deaktivovat`)
};

const en_templates_deactivate = /** @type {(inputs: Templates_DeactivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivate`)
};

/**
* | output |
* | --- |
* | "Deactivate" |
*
* @param {Templates_DeactivateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_deactivate = /** @type {((inputs?: Templates_DeactivateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_DeactivateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_deactivate(inputs)
	return cs_templates_deactivate(inputs)
});